import script from "./CardCourse.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardCourse.vue?vue&type=script&lang=ts&setup=true"

import "./CardCourse.vue?vue&type=style&index=0&id=541654d7&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CardCourse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541654d7"]])

export default __exports__